<div class="account">
  <ng-container
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Display name',
      value: accountDetails?.displayName
    }"
  >
  </ng-container>
  <ng-container
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Category',
      value: accountCategoriesDictionary[accountDetails?.category]?.displayName
    }"
  >
  </ng-container>
  <ng-container
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Description',
      value: accountDetails?.description
    }"
  >
  </ng-container>
  <ng-container
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Created',
      value: accountDetails?.created | date
    }"
  >
  </ng-container>
  <ng-container
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Expiration date',
      value: accountDetails?.expirationDate
        ? (accountDetails?.expirationDate | date)
        : '',
      lock: accountDetails?.expirationDate
        ? 'Expired accounts are LOCKED after one full grace period day that follows the expiration date. This account gets LOCKED automatically on ' +
          lockDate +
          ' early in the morning.'
        : null,
      delete:
        accountDetails?.expirationDate && accountDetails?.category === 'trial'
          ? 'Expired Trial accounts are SUSPENDED and TERMINATED after 7 days from the expiration date. Then they are DELETED after another 30 days.'
          : null
    }"
  >
  </ng-container>
  <ng-container
    *ngIf="hasSubscriptionId"
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Subscription Id',
      value: accountDetails?.sbmRef
        ? 'https://submariners.efficy.cloud/page/subs/' + accountDetails?.sbmRef
        : 'N/A',
      templateRef: subscriptionId
    }"
  >
  </ng-container>
  <ng-container
    [ngTemplateOutlet]="info"
    [ngTemplateOutletContext]="{
      title: 'Last Login',
      value: lastUserLoginTime | date: 'yyyy/MM/dd H:mm'
    }"
  >
  </ng-container>
</div>

<ng-template #subscriptionId let-value="value">
  <a
    target="_blank"
    rel="noopener noreferrer"
    *ngIf="value !== 'N/A'; else default"
    class="subscriptionId"
    [href]="value"
    >Navigate to Submariner</a
  >
  <ng-template #default>{{ value }}</ng-template>
</ng-template>

<ng-template
  #info
  let-title="title"
  let-value="value"
  let-lock="lock"
  let-delete="delete"
  let-templateRef="templateRef"
>
  <div class="account__item">
    <div class="account__item__data">
      <span class="account__item__data--title">{{ title }}</span>
      <div class="account__item__data--value" *ngIf="templateRef; else default">
        <ng-container
          [ngTemplateOutlet]="templateRef"
          [ngTemplateOutletContext]="{ value: value }"
        ></ng-container>
      </div>

      <ng-template #default
        ><span class="account__item__data--value">{{
          value
        }}</span></ng-template
      >
    </div>
    <span class="account__item__lock" *ngIf="lock"
      ><i class="fa fa-exclamation-triangle"></i> Automatic LOCK <br />
      {{ lock }}</span
    >
    <span class="account__item__delete" *ngIf="delete"
      ><i class="fa fa-exclamation-triangle"></i> Automatic DELETE <br />
      {{ delete }}</span
    >
  </div>
</ng-template>
